import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BookOpen, Quote as QuoteIcon } from "lucide-react";

export default function DailyContent() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/daily-content").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) {
    return (
      <div className="grid md:grid-cols-2 gap-6" data-testid="daily-content-loading">
        <div className="h-40 bg-muted rounded-2xl animate-pulse" />
        <div className="h-40 bg-muted rounded-2xl animate-pulse" />
      </div>
    );
  }

  return (
    <div className="grid md:grid-cols-2 gap-6" data-testid="daily-content">
      <article className="rounded-2xl p-7 bg-card border border-border shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
            <BookOpen className="w-5 h-5" />
          </span>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-primary">
            Palabra del día
          </p>
        </div>
        <p className="font-display text-2xl leading-snug text-foreground" data-testid="daily-verse-text">
          “{data.verse.text}”
        </p>
        <p className="mt-4 text-sm text-secondary font-semibold">{data.verse.ref}</p>
      </article>

      <article className="rounded-2xl p-7 bg-primary text-primary-foreground shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-10 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center">
            <QuoteIcon className="w-5 h-5" />
          </span>
          <p className="text-xs tracking-[0.2em] uppercase font-semibold opacity-80">
            San Francisco hoy
          </p>
        </div>
        <p className="font-display text-2xl leading-snug" data-testid="francis-quote-text">
          “{data.francis_quote}”
        </p>
        <p className="mt-4 text-sm opacity-70">— San Francisco de Asís</p>
      </article>
    </div>
  );
}
